
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/workday",
      function () {
        return require("private-next-pages/destinations/workday.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/workday"])
      });
    }
  